import { DATASETS } from '../actions/types';
import createReducer from './createReducer';

const reduceDatasets = {
  [DATASETS.REQUEST_SUCCEEDED]: (prevState, payload) => payload.domains,
  // more datasets reducers here
};

export default createReducer(null, reduceDatasets);
